import {SVGAttributes} from 'react';
import LogoIcon from "@/Components/Icons/LogoIcon";

export default function ApplicationLogo(props: SVGAttributes<SVGElement>) {
    return (
        <div className="notranslate text-left text-2xl  text-gray-600 dark:text-gray-200 flex items-start"  >
            <LogoIcon/>
            <span className="font-medium">SubtitleExtractor</span>
        </div>
    );
}
